<template>
    <div class="bulma">
    <div class="modal"
         v-if="show"
         :class="{ 'is-active': show }"
         >

        <div class="modal-background" @click="hideModal"></div>
        <div class="modal-card">

            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ errorTitle }}
                </p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="hideModal"
                ></button>
            </header>

            <section class="modal-card-body">
                <div class="content">
                    <p v-if="isInterruptMode">
                        {{ errorMessage }}
                        <br><br>
                        {{ trans.interrupt_message_notification }}
                    </p>
                    <p v-else>
                        {{ errorMessage }}
                    </p>
                </div>
            </section>

            <footer class="modal-card-foot">
                <button
                    v-if="isInterruptMode"
                    class="button is-info"
                    @click="interrupt"
                >
                    {{ trans.interrupt_button }}
                </button>
                <button
                    class="button"
                    @click="hideModal">
                    {{ cancelButtonText }}
                </button>
            </footer>
        </div>
    </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: "EditingSessionInterruptModal",
    props: {
      trans: Object,
    },
    computed: {
        ...mapState('documentEditSession',
            {
                show: 'isSessionInterruptionModalShown',
            }),
        ...mapGetters('documentEditSession',
            [
                'errorTitle',
                'errorMessage',
                'isInterruptMode',
            ]
        ),
        cancelButtonText() {
            return this.isInterruptMode ? this.trans.cancel_button : this.trans.button_close;
        },
    },
    methods: {
        ...mapActions('documentEditSession',
            {
                hideModal: 'hideSessionInterruptionModal',
            }
        ),
        interrupt: function () {
            let hash = getContentHash();
            let url = Utils.replaceWildcards(actions.session.start, {document_hash: hash});
            axios.post(url, {interrupt: true})
                .then(response => {
                    sendGAEvent('Сессия редактирования документа была прервана');
                    if (response.status) {
                        this.hideModal();
                        window.editDocumentClick();
                    }
                })
        },
    }
}
</script>
